module.exports = __webpack_public_path__ + "static/img/pic2.b77dfa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic2.png
// module id = 34Bi
// module chunks = 0